import React from 'react';
import { Button, Box, Paper } from '@mui/material';

import useApplications from './useApplications';
import RenderIf from '../../renderIf';
import Markdown from '../adminApplication/markdown';
import { BiColorHeader } from '../scholarshipApplication/components';
import { Card, Notification } from './components';
import ShipyardNotification from '../../shared/notification';

const ApplicantDashboard = () => {
    const { isRetrieving, isCreating, availableApplications, applicationInstances, retrieveApplications, createApplication } =
        useApplications();

    React.useEffect(() => {
        retrieveApplications();
    }, []);

    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    margin: (theme) => theme.spacing(5),
                }}
            >
                <RenderIf isTrue={isRetrieving || applicationInstances?.length > 0}>
                    <BiColorHeader
                        left="My"
                        right="Applications."
                    />
                </RenderIf>

                <RenderIf isTrue={applicationInstances?.length === 0}>
                    <Markdown sx={{ fontSize: '36px' }}>{availableApplications?.[0]?.name['en-US']}</Markdown>
                </RenderIf>

                <RenderIf isTrue={!isRetrieving && applicationInstances?.length === 0}>
                    <Button
                        onClick={() => createApplication()}
                        variant="contained"
                        disabled={isCreating}
                    >
                        Create Application
                    </Button>
                </RenderIf>
            </Box>

            <RenderIf isTrue={applicationInstances?.length > 0 && applicationInstances.some((appInst) => appInst?.Status?.id === 7)}>
                <ShipyardNotification
                    text={'Your application has been Rejected. You may click "View Application" to see the reason.'}
                    collapsible={false}
                />
            </RenderIf>

            <RenderIf isTrue={!isRetrieving}>
                <RenderIf
                    isTrue={
                        applicationInstances?.length > 0 &&
                        applicationInstances.some((appInst) => appInst?.Status === 3 || appInst?.Status?.id === 3)
                    }
                >
                    {applicationInstances.map((appInst) => {
                        //#TODO TechDebt - Recieve this message from the database to have it configurable per client.
                        return (
                            <Notification
                                message={`Attention! ${availableApplications[0].id === 7 ? 'Your' : `${appInst.StudentName}'s`} application has been reviewed and returned.  Click Edit application to see more information.`}
                            />
                        );
                    })}
                </RenderIf>

                <RenderIf isTrue={applicationInstances?.length > 0}>
                    {applicationInstances.map((appInst, i) => {
                        return (
                            <Card
                                appInst={appInst}
                                displayKeys={[
                                    { key: 'StartDate', label: 'Application Date', type: 'date' },
                                    { key: 'Status', label: 'Application Status', type: 'status' },
                                ]}
                                key={`card-${i}`}
                            />
                        );
                    })}
                </RenderIf>

                <RenderIf isTrue={applicationInstances?.length === 0}>
                    <Paper
                        sx={{
                            margin: (theme) => theme.spacing(5),
                            borderRadius: '8px',
                            padding: (theme) => theme.spacing(4),
                            paddingLeft: (theme) => theme.spacing(6),
                        }}
                    >
                        <Markdown>{availableApplications?.[0]?.headerMarkdown['en-US']}</Markdown>
                    </Paper>
                </RenderIf>
            </RenderIf>

            <RenderIf isTrue={isRetrieving}>
                <Card
                    appInst={{ ID: 'loading' }}
                    displayKeys={[...Array(5).fill({ type: 'loading' })]}
                />
            </RenderIf>
        </Box>
    );
};

export default ApplicantDashboard;
